module.exports = __webpack_public_path__ + "images/4a123e196650de17feb2e523e1d1c6b8.svg";